module.exports = __webpack_public_path__ + "media/icons/white-video-7c365e63.png";